<template>
  <div class="pesquisa-mensagem">
    <div
        class="sucesso-pesquisa-titulo"
    >
      <img
        :src="urlIcone"
        :height=height
        :width=width
      />
<!--      {{ icone }}-->
    </div>
    <div
        class="sucesso-pesquisa-titulo"
    >
      {{ titulo }}
    </div>
    <div
        class="sucesso-pesquisa-texto"
    >
      {{ descricao }}
    </div>
  </div>
</template>
<script>
import { urlIcons } from '@/utils/ImageBucket'

export default {
  name: 'PesquisaMensagem',
  props: {
    icone: {
      type: String,
      default: ''
    },
    cor: {
      type: String,
      default: ''
    },
    titulo: {
      type: String,
      default: ''
    },
    descricao: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '60'
    },
    width: {
      type: String,
      default: '60'
    }
  },
  computed: {
    urlIcone () {
      return urlIcons(this.icone)
    }
  }
}
</script>
<style lang="less">
.pesquisa-mensagem {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-height: 500px;

  .sucesso-pesquisa-titulo {
    text-align: center;
    font: normal normal 600 18px/24px Open Sans;
    letter-spacing: 0;
    color: #333333;
    opacity: 1;
    margin-bottom: 20px;
  }

  .sucesso-pesquisa-texto {
    text-align: center;
    font: normal normal normal 14px/19px Open Sans;
    letter-spacing: 0;
    color: #000000;
    opacity: 0.8;
    margin-bottom: 15px;
  }
}
</style>
